import {
  InfoPanelTitle,
  InfoPanelDescription,
  InfoPanelLinks,
  InfoPanelFooter,
} from '@/features/jobs/details/tax-type/tax-prep-organizer/components/InfoPanel'

export function BusinessIncomeTaxTreatmentInfoContent() {
  return (
    <>
      <InfoPanelTitle>
        How is your business income treated for tax purposes?
      </InfoPanelTitle>
      <InfoPanelDescription>
        <p>
          How you are treated for taxes depends on how involved you were in
          operating your business during the year. This determines if your
          income is passive or non-passive, which affects how you can use losses
          and whether you owe certain taxes.
        </p>

        <p>
          <strong>Options:</strong>
        </p>
        <ul>
          <li>
            <p>
              <strong>Passive business activity:</strong> You do not take part
              in your business on a regular, continuous, or meaningful basis. In
              this case, your income is treated as passive and may be subject to
              the Net Investment Income Tax.
            </p>
          </li>
          <li>
            <p>
              <strong>Non-passive business activity:</strong> You are actively
              involved in running your business, such as making decisions,
              handling operations, or managing daily work. This makes your
              income non-passive.
            </p>
          </li>
        </ul>
      </InfoPanelDescription>
      <InfoPanelFooter>
        <InfoPanelLinks
          links={[
            {
              label: 'Instructions for Form 8960, Net Investment Income Tax',
              url: 'https://www.irs.gov/instructions/i8960',
            },
          ]}
        />
      </InfoPanelFooter>
    </>
  )
}
